(() => {
  const desktopMenu = window.matchMedia('(min-width: 990px)');
  const selector = '.header__inline-menu header-menu > details';
  const closeTimers = new WeakMap();

  function setOpen(details, open) {
    details.toggleAttribute('open', open);
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
  }

  function closeOtherMenus(current) {
    document.querySelectorAll(selector).forEach((details) => {
      if (details !== current) setOpen(details, false);
    });
  }

  function clearCloseTimer(details) {
    const timer = closeTimers.get(details);
    if (timer) window.clearTimeout(timer);
  }

  function keepPanelInViewport(details) {
    const panel = details.querySelector(':scope > .mega-menu__content');
    if (!panel) return;

    panel.style.removeProperty('--wcf-submenu-shift-x');
    const panelRect = panel.getBoundingClientRect();
    const safeEdge = 16;
    const shift = panelRect.right > window.innerWidth - safeEdge
      ? window.innerWidth - safeEdge - panelRect.right
      : panelRect.left < safeEdge
        ? safeEdge - panelRect.left
        : 0;
    panel.style.setProperty('--wcf-submenu-shift-x', `${Math.round(shift)}px`);
  }

  function openMenu(details) {
    clearCloseTimer(details);
    closeOtherMenus(details);
    setOpen(details, true);
    window.requestAnimationFrame(() => keepPanelInViewport(details));
  }

  function bindMenu(details) {
    if (details.dataset.wcfHoverMenuBound === 'true') return;
    details.dataset.wcfHoverMenuBound = 'true';

    details.addEventListener('pointerenter', (event) => {
      if (!desktopMenu.matches || event.pointerType === 'touch') return;
      openMenu(details);
    });

    details.addEventListener('pointerleave', (event) => {
      if (!desktopMenu.matches || event.pointerType === 'touch') return;
      clearCloseTimer(details);
      closeTimers.set(
        details,
        window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            setOpen(details, false);
          }
        },
        150)
      );
    });

    details.addEventListener('focusin', () => {
      if (desktopMenu.matches) openMenu(details);
    });
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(bindMenu);
  }

  window.addEventListener('resize', () => {
    if (!desktopMenu.matches) return;
    document.querySelectorAll(`${selector}[open]`).forEach(keepPanelInViewport);
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();